import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = "Confirm", onConfirm, danger, children }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="confirm-dialog" className="bg-[#0A1024] border-[#243153] text-[#F7FAFF]">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display">{title}</AlertDialogTitle>
        <AlertDialogDescription className="text-[#AAB6CC]">{description}</AlertDialogDescription>
      </AlertDialogHeader>
      {children}
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-dialog-cancel" className="cq-btn cq-btn-ghost bg-transparent">Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-dialog-confirm" onClick={onConfirm} className={`cq-btn ${danger ? "cq-btn-danger !bg-[#FF7792]/15 !text-[#FF7792] border !border-[#FF7792]/40 hover:!bg-[#FF7792]/25" : "cq-btn-primary"}`}>
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
